import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Химия. 11 класс",
        subject: " Химическое загрязнение окружающей среды и его последствия",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: " Химическое загрязнение окружающей среды и его последствия",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Заграничная Надежда Анатольевна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории профильного образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>" +
                                "<p>В содержании обучения химии, согласно Федеральной образовательной программе среднего общего образования (2023 г), представлен раздел «Химия и жизнь». В связи с этим возникла необходимость методической поддержки работы учителей в направлении экологического воспитания и обучения школьников, формирования естественно-научной грамотности выпускников средней школы при изучении заключительного раздела курса 11 классе.   </p>" +
                                "<p>Содержание урока «Химическое загрязнение окружающей среды и его последствия» обобщает знания и представления выпускников об экологических  проблемах, связанных с химическими технологиями. В то же время, отбор современного и актуального учебного материала, приближенного к жизненным интересам молодёжи, является ещё не решенной задачей, и может вызывать затруднения в работе учителя химии.  </p>" +
                                "<p>Материалы данного кейса будут полезны учителю-предметнику как в определении содержания обучения на уроке, так и при организации учебно-познавательной деятельности обучающихся в урочной и внеурочной работе.  </p>" +
                                "<p>В составе материалов кейса: </p>" +
                                "<ul>" +
                                "<li>приведены актуальные примеры жизненных ситуаций, соответствующих теме урока; </li>" +
                                "<li>рассмотрены возможности использования приёмов межпредметной и внутрипредметной интеграции для более полного раскрытия содержания;</li>" +
                                "<li>предложены варианты организации учебно-познавательной деятельности школьников при рассмотрении вопросов химической экологии на уроке;</li>" +
                                "<li>включён дидактический материал (задания разной сложности) для обучающихся, который учитель может использовать как на уроке, так и для домашней работы;</li>" +
                                "<li>приведён текст методической статьи, посвящённой реализации современных принципов экологического образования при изучении химии в школе.</li>" +
                                "</ul>" +
                                "</div>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `
                    <p style="text-indent: 2vw;">Раздел «Химия и жизнь» завершает курс химии среднего общего образования. </p>
                    <p style="text-indent: 2vw;">Содержание урока «Химическое загрязнение окружающей среды и его последствия» изучается на основе установления внутрипредметных связей между курсами органической и неорганической химии, а также с учётом межпредметной интеграции с физикой, биологией и экологией.</p>
                    
                    <p style="text-indent: 2vw;">План изучения темы следующий:</p>
                    <p style="text-indent: 2vw;">
                    <ul>
                    <li>Химическое загрязнение окружающей среды. (Актуализация проблемы урока. Основные понятия.).</li>
                    <li>Какие вещества являются химическими загрязнителями? Какими свойствами они обладают? (Формулирование гипотезы).</li>
                    <li>Воздействие некоторых химических веществ на природу и организм человека (Обоснование гипотезы, экспериментальная проверка гипотезы).</li>
                    <li>Как бороться с загрязнением окружающей среды? (Следствия из гипотезы).</li>
                    <li>Выводы.</li>
                    </ul>
                    </p>
                    <p style="text-indent: 2vw;">На уроке учитель может использовать частично-поисковый или проблемный метод обучения. В рамках каждого метода обучения необходимо предлагать ученикам размышлять о причинах тех или иных явлений, прогнозировать возможные последствия активного вмешательства человека в окружающую среду.</p>
                    <p style="text-indent: 2vw;">Выбор метода и наиболее подходящих форм организации учебной работы зависит от уровня подготовленности обучающихся к самостоятельной учебно-познавательной деятельности. Это могут быть как традиционные (урок-беседа, урок-семинар, урок-лабораторная, урок-практикум, урок-зачёт, урок-компьютерное занятие), так и нетрадиционные (урок-турнир, урок-КВН, урок-ролевая игра, урок-викторина, урок-репортаж, урок-пресс-конференция, урок-митинг, урок-суд, урок-путешествие) формы уроков.</p>
                
                
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Приказ Минпросвещения России от 12.08.2022 N 732 «О внесении изменений в федеральный государственный образовательный стандарт среднего общего образования», утверждённый приказом Министерства образования и науки Российской Федерации от 17 мая 2012 г. N 413 URL: https://fgos.ru/fgos/fgos-ooo/  (Дата обращения: 04.03.2023)",
                "Федеральная образовательная программа среднего общего образования  URL:https://edsoo.ru/Federalnaya_obrazovatelnaya_programma_srednego_obschego_obrazovaniya.htm (Дата обращения: 14.02.2023)",
                "Заграничная Н.А. Профессиональное саморазвитие учителя химии. Воспитательный потенциал курса химии как основа формирования личностных результатов обучения. 8–11 классы. Серия «Методическая лаборатория». – Волгоград: Учитель. – 2015",
                "Заграничная Н.А. Химическое образование в средней школе – важный компонент формирования экологической культуры учащихся/ Экологическое образование для устойчивого развития: теория и педагогическая реальность: Материалы Международной научно-практической конференции – Н.Новгород: НГПУ им. К. Минина, 2015",
                "Заграничная Н.А., Паршутина Л.А. Интеграция содержания и методов преподавания естественнонаучных предметов в школьном образовании / Н.А. Заграничная, Л.А. Паршутина // Педагогика. 2018, №9",
                "Заграничная Н.А., Паршутина Л.А. Функциональная грамотность учащихся: условия и пути формирования// Химия в школе. 2020, №7",
                "Ковалёва Г.С., Пентин А.Ю., Заграничная Н.А. и др. Естественно-научная грамотность: сборник эталонных заданий. Выпуск 2: учебное пособие для общеобразовательных организаций / [Г.С. Ковалёва, А.Ю. Пентин, Е.А. Заграничная Н.А. и др.]; под ред. Г.С. Ковалёвой, А.Ю. Пентина. — Москва; Санкт-Петербург: Просвещение, 2021. – 143с.: ил. — (Функциональная грамотность. Учимся для жизни)",
                "Савинкина Е.В., Логинова Г.П. Химия. Для школ и классов гуманитарного профиля: Учебник. 10 класс. – Москва: АСТ-ПРЕСС, 2001",
                "Единое содержание общего образования (edsoo.ru)",
                "Сайт ИСРО. Режим достyпа: https://skiv.instrao.ru",
                "Российская электронная школа (resh.edu.ru)",
            ],
            sites: [],
            filesToDownload: [
                {
                    link: "./files/additional1.pdf",
                    fileName: "Интерактивные задания"
                },
                {
                    link: "./files/additional2.pdf",
                    fileName: "Методическая статья"
                },
                {
                    link: "./files/additional3.pdf",
                    fileName: "Текстовые задания"
                }
            ]
        }
    ],
};
